import { MultimediaIcon } from './MultimediaIcon';

/**
 * author: Michael Irigoyen
 * id 2EE192A7-497B-41B8-B68A-34A32B8445F2
 * name multimedia
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/multimedia.svg
 * tags
 * - Audio 
 * - Video / Movie 
 * - Photography 
 */
export const PictureIcon = MultimediaIcon;
export default PictureIcon